/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  browse: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearch',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/BrowseAndSearch.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/BrowseAndSearch.js')).BrowseAndSearch
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearch })))
    },
    path: '/:context?/b',
    channel: null
  },

  search: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearch',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/BrowseAndSearch.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/BrowseAndSearch.js')).BrowseAndSearch
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearch })))
    },
    path: '/:context?/s',
    channel: null
  },

  pep: {
    name: 'pep',
    componentName: 'Pep',
    chunk: () => import(
      /* webpackChunkName: "pep" */
      './pages/Pep.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Pep.js')).Pep
        : currentRouteName === 'pep'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Pep })))
    },
    path: '/:context?/pep/:slug?/:itemId',
    channel: 'desktop'
  },

  // @TODO: Named export doesn't match the component file name.
  pepMobile: {
    name: 'pep-mobile',
    componentName: 'PepMobile',
    chunk: () => import(
      /* webpackChunkName: "pep-mobile" */
      './pages/mobile/Pep.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/mobile/Pep.js')).PepMobile
        : currentRouteName === 'pep-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepMobile })))
    },
    path: '/:context?/pep/:slug?/:itemId',
    channel: 'mobile'
  },

  product: {
    name: 'product',
    componentName: 'Product',
    chunk: () => import(
      /* webpackChunkName: "product" */
      './pages/Product.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Product.js')).Product
        : currentRouteName === 'product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Product })))
    },
    path: '/:context?/p/:slug?/:itemId',
    channel: null
  },

  compare: {
    name: 'compare',
    componentName: 'Compare',
    chunk: () => import(
      /* webpackChunkName: "compare" */
      './pages/Compare.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Compare.js')).Compare
        : currentRouteName === 'compare'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Compare })))
    },
    path: '/:context?/compare',
    channel: null
  },

  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })))
    },
    path: '/:context?/',
    channel: null
  },
});
